import { Vue } from 'vue-property-decorator';

import * as Config from '@/data/config.json'
import * as Dictionary from '@/data/dictionary.json'
import { IConfig, IDictionary, IData, IStatement, IResult, IPartyStatement, IShootoutStatement } from './interfaces';
import { State } from './store';

//import * as Data from '@/data/data.json'
import CryptedData from '@/data/crypted'
const decrypt = decodeURI(atob(CryptedData));
const Data = { default: JSON.parse(decrypt)};

export default class GlobalMixins extends Vue {
	config: IConfig = (Config as any).default
	dictionary: IDictionary = (Dictionary as any).default
	votematch: IData["votematch"] = (Data as any).default.votematch
	parties: IData["parties"] = (Data as any).default.parties
	rawStatements: IData["statements"] = (Data as any).default.statements
	rawShootoutStatements: IData["shootoutStatements"] = (Data as any).default.shootoutStatements
	partyNameForChoicesOverviewTitle: string = ''
	updateCounter: number = 0

	get user(): State['user'] {
		return this.$store.getters.user
	}
	get statements(): IStatement[] {
		return this.$store.getters.statements
	}
	get shootoutStatements(): IShootoutStatement[] {
		return this.$store.getters.shootoutStatements()
	}
	get amountSkipped(): number {
		const filledInStatements = this.user.choices.reduce((total, choice) => {
			return total + (choice.choice !== 'skip' ? 1 : 0)
		}, 0)

		return filledInStatements
	}
	get maxScore(): number {
		this.updateCounter

		let maxScore = 0

		if (this.user.priorityStatements && this.user.priorityStatements.length) {
			maxScore += this.user.priorityStatements.length
		}

		this.user.choices.forEach(statement => {
			if (statement.choice !== 'skip') maxScore++
		})

		return maxScore
	}
	get isEmbedded(): boolean {
		return window.location !== window.parent.location
	}

	results(onlySelected: boolean): IResult[] {
		if (this.$route.name !== 'select-analytics' && this.$route.name !== 'results' && this.$route.name !== 'choices-overview') return []

		let results: IResult[] = []
		let savedResults = this.$store.getters.savedResults

		if (savedResults) {
			if (JSON.stringify(this.user.choices) === savedResults.userChoicesString) {
				results = savedResults.results
			} else {
				this.$store.dispatch('setSavedResults', false)
				
				savedResults = false
			}
		}

		if (!results.length) {
			this.parties
				.filter(party => {
					return party.participates
				})
				.forEach(party => {
					let percentage = 0

					if (party.statements && party.statements.length) {
						this.statements.forEach(statement => {
							const userChoice = this.user.choices
								.filter(uStatement => {
									return (uStatement.originalStatementId === statement.id)
								})[0].choice
							const partyPosition = (party.statements as IPartyStatement[])
								.filter(pStatement => {
									return (pStatement.id === statement.id)
								})[0].position
							const isDoubled = this.user.priorityStatements ? this.user.priorityStatements.indexOf(statement.id) !== -1 : false

							if (userChoice !== 'skip' && userChoice === partyPosition) {
								percentage += (((isDoubled ? 2 : 1) / this.maxScore) * 100)
							}
						})
					}

					results.push({
						party,
						percentage: Math.round(percentage)
					})
				})

			results.sort((a, b) => {
				if (a.percentage === b.percentage) return 0
				if (a.percentage > b.percentage) return -1

				return 1
			})
		}

		if (!savedResults) {
			this.$store.dispatch('setSavedResults', {
				userChoicesString: JSON.stringify(this.user.choices),
				results
			})
		}

		if (onlySelected) {
			results = results.filter(result => {
				let partyId = -1

				this.parties.forEach(party => {
					if (JSON.stringify(party) === JSON.stringify(result.party)) partyId = party.id
				})

				return (partyId !== -1 && (this.user.selectedParties as number[]).indexOf(partyId) !== -1)
			})
		}

		return results
	}
	slugify(string: string): string {
		const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõőṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
		const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnoooooooooprrsssssttuuuuuuuuuwxyyzzz------'
		const p = new RegExp(a.split('').join('|'), 'g')

		return string.toString().toLowerCase()
			.replace(/\s+/g, '-')
			.replace(p, c => b.charAt(a.indexOf(c)))
			.replace(/&/g, '-and-')
			.replace(/[^\w\-]+/g, '')
			.replace(/\-\-+/g, '-')
			.replace(/^-+/, '')
			.replace(/-+$/, '')
	}
	shareLink(platform: 'facebook' | 'twitter' | 'linkedin' | 'whatsapp'): string {
		let linkToModify: string = ''

		if (this.$route.name === 'statement') {
			if (this.dictionary.statement.share) {
				switch (platform) {
					case 'facebook':
						linkToModify = this.dictionary.statement.share.facebookWithStatement
						break
					case 'twitter':
						linkToModify = this.dictionary.statement.share.twitterWithStatement
						break
					case 'linkedin':
						linkToModify = this.dictionary.statement.share.linkedinWithStatement
						break
					case 'whatsapp':
						linkToModify = this.dictionary.statement.share.whatsappWithStatement
						break
				}
			}

			linkToModify = linkToModify.replace('[shareStatementUrl]', `${window.location.host}?${this.slugify(this.dictionary.statement.tabTitle)}=${(this.$store.getters.statement().id + 1)}`)
			linkToModify = linkToModify.replace('[statementTitle]', this.$store.getters.statement().title)
		} else {
			switch (platform) {
				case 'facebook':
					linkToModify = this.dictionary.app.share.facebook
					break
				case 'twitter':
					linkToModify = this.dictionary.app.share.twitter
					break
				case 'linkedin':
					linkToModify = this.dictionary.app.share.linkedin
					break
				case 'whatsapp':
					linkToModify = this.dictionary.app.share.whatsapp
					break
			}

			linkToModify = linkToModify.replace('[appUrl]', `${window.location.host}`)
		}

		return linkToModify
	}
	statementTitleToString(title: IStatement['title'] | IShootoutStatement['title']): string {
		if (typeof title === 'string') return title

		let stringTitle = ''

		title.forEach(titlePart => {
			if (stringTitle) stringTitle += ' '

			if (typeof titlePart === 'string') {
				stringTitle += titlePart
			} else {
				stringTitle += titlePart.text
			}
		})

		return stringTitle
	}
	setDocumentTitle() {
		let title = ''

		if (this.$route.name === 'statement' || this.$route.name === 'shootout-statement') {
			title = `${this.dictionary.app.title} | ${this.$route.name === 'shootout-statement' ? this.dictionary.shootoutStatement.tabTitle : this.dictionary.statement.tabTitle} ${this.$route.params.id} | ${this.statementTitleToString((this.$store.getters.statement(JSON.parse(this.$route.params.id)) as IStatement).title)}`
		} else if (this.$route.meta.title) {
			title = `${this.dictionary.app.title} | ${this.$route.meta.title}`
		} else {
			title = `${this.dictionary.app.title}`
		}

		try {
			document.getElementsByTagName('title')[0].innerHTML = title.replace('<', '&lt;').replace('>', '&gt;').replace(' & ', ' &amp; ')
		}
		catch (Exception) { }

		document.title = title
	}
	trackGAEvent(event: string) {
		// extra check to ensure ga is enabled
		if (typeof gtag !== 'undefined') { 
			if (process.env.VUE_APP_GOOGLE_ANALYTICS_ID && gtag) {
				let category = "vmEvent";
				if (this.config.settings.analytics.title) {
					category = `${this.config.settings.analytics.title}`
				}
				if (this.config.settings.analytics.gaEventCategory) {
					category = `${this.config.settings.analytics.gaEventCategory}`
				}				
				
				gtag('event', event, {
					'event_category': category,
					'event_label': location.href
				});
			}
		}
	}
}
